// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + chunkId + "." + {"425":"bab775111ede6ef736fc","460":"15572df59b761043e350","506":"590ece29e47258f33c12","819":"f7d1b5f55557fdd28b3f"}[chunkId] + ".js";
};